<template>
  <div>
    <el-dialog
      custom-class="App-Create-Business-Modal App-Unpadded"
      :model-value="isModalOpen"
      width="550px"
      :show-close="showClose"
      :close-on-click-modal="showClose"
      :close-on-press-escape="showClose"
      @open="opened"
      title="Update Startup Profile"
      center
      :append-to-body="true"
      :lock-scroll="true"
      :open-delay="200"
      :before-close="closeModal"
      :close-delay="200"
    >
      <!--  -->
      <el-scrollbar :always="true" v-loading="loading" max-height="70vh">
        <div>
          <el-form
            @submit.prevent
            class="App-Styled-Form"
            :label-position="'top'"
            label-width="100px"
            :model="form"
            style="margin-top: 12px"
            :rules="rules"
          >
            <!--  -->
            <!-- name -->
            <el-form-item prop="name" label="Name">
              <el-input placeholder="E4T" v-model="form.name" />
            </el-form-item>
            <!--  -->
            <!-- Industry -->
            <el-form-item prop="industry" label="Industry">
              <el-select
                v-model="form.industry"
                placeholder="Industry: ex: Edtech"
                w-100
              >
                <el-option
                  v-for="ind in industries"
                  :value="ind"
                  :label="ind"
                  :key="`${ind}-ind`"
                >
                  <el-space>
                    <i class="App-Loc-Icon el-icon-business" />
                    <span>{{ ind }}</span>
                  </el-space>
                </el-option>
              </el-select>
            </el-form-item>
            <!--  -->
            <!-- businessModel -->
            <el-form-item
              prop="businessModel"
              label="What is your business model?"
            >
              <el-select
                v-model="form.businessModel"
                placeholder="Business Model: ex: Edtech"
                w-100
              >
                <el-option
                  v-for="ind in businessModels"
                  :value="ind"
                  :label="ind"
                  :key="`${ind}-ind`"
                >
                  <el-space>
                    <i class="App-Loc-Icon el-icon-business" />
                    <span>{{ ind }}</span>
                  </el-space>
                </el-option>
              </el-select>
            </el-form-item>
            <!--  -->
            <el-divider />
            <!-- Location -->
            <app-location-search
              label="Where are you based?"
              :size="'default'"
              v-model="form.location"
            />
            <!--  -->
            <el-divider />
            <!--  -->
            <!-- stage -->
            <el-form-item prop="stage" label="Startup Stage">
              <el-select
                v-model="form.stage"
                placeholder="Startup Stage: ex: MVP"
                w-100
              >
                <el-option
                  v-for="ind in stages"
                  :value="ind"
                  :label="ind"
                  :key="`${ind}-ind`"
                >
                  <el-space>
                    <i class="App-Loc-Icon el-icon-business" />
                    <span>{{ ind }}</span>
                  </el-space>
                </el-option>
              </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item
              prop="teamSize"
              label="Team Size (Co-founders + others)"
            >
              <el-input-number
                w-100
                :controls="false"
                placeholder="How big is the team?"
                v-model="form.teamSize"
              />
            </el-form-item>
            <!--  -->
            <!--  -->
            <el-divider />
            <!-- website -->
            <el-form-item prop="website" label="Website if any">
              <el-input
                placeholder="https://equity4talent.com"
                v-model="form.website"
              />
            </el-form-item>
            <!--  -->
            <el-divider />
            <!--  -->
            <!-- foundingYear -->
            <el-form-item prop="foundingYear" label="Founding Year">
              <el-input-number
                w-100
                v-model="form.foundingYear"
                :controls="false"
                placeholder="Pick a year"
              />
            </el-form-item>
            <!--  -->
            <!-- marketSize -->
            <el-form-item prop="marketSize" label="Market Size">
              <el-input
                :controls="false"
                placeholder="200,000"
                v-model="form.marketSize"
              />
            </el-form-item>
            <!--  -->
            <!-- Raised Fund -->
            <el-form-item prop="funding" label="Funds Raised">
              <el-space :size="12">
                <el-select
                  v-model="form.funding.currency"
                  placeholder="Currency"
                  style="width: 150px"
                >
                  <el-option label="£ (Pound)" value="gbp"></el-option>
                  <el-option label="$ (US Dollars)" value="usd"></el-option>
                  <el-option label="€ (Euros)" value="euro"></el-option>
                </el-select>
                <el-input-number
                  w-100
                  :controls="false"
                  placeholder="200,000"
                  v-model="form.funding.amount"
                />
              </el-space>
            </el-form-item>
            <!--  -->
            <!--  -->
            <!-- Bio About -->
            <el-form-item prop="about" label="Description">
              <el-input
                rows="5"
                type="textarea"
                placeholder="Description"
                v-model="form.about"
              />
            </el-form-item>
            <!--  -->
            <!--  -->
            <!--  -->
            <!--  -->
          </el-form>
        </div>
      </el-scrollbar>
      <!--  -->
      <template #footer>
        <div txt-center>
          <el-button
            is-block
            icon="el-icon-check"
            @click="submit"
            size="large"
            type="primary"
            :disabled="disabledSave || loading"
          >
            Save Startup Changes
          </el-button>
        </div>
      </template>
      <!--  -->
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { FounderAccountUtil } from "@/@business/store";
import { ErrorUtil } from "@/shared";
import {
  Business,
  BusinessModels,
  BusinessStages,
  IndustriesList,
  User
} from "@/shared/interfaces";
import { ObjectUtil } from "@/shared/utils";
import { Options, Vue } from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { BusinessFormRules } from "./business-form";

@Options({
  emits: ["checked", "opened", "closed"],
  components: {},
})
export default class extends Vue {
  /**
   *
   */
  @Prop({ type: Boolean })
  isModalOpen!: boolean;

  showClose = true;
  //
  industries = IndustriesList;
  //
  stages = BusinessStages;
  businessModels = BusinessModels;

  @Prop({ type: Object })
  business!: Business;

  /**
   *
   */
  rules = BusinessFormRules;
  mounted() {
    console.log("Mounted with ", this.$store.state.account);
    this.rules.coFoundersSize = undefined as any;
    this.assignForm();
  }

  form = {
    name: undefined,
    industry: undefined,
    businessModel: undefined,
    location: undefined,
    stage: undefined,
    teamSize: undefined,
    website: undefined,
    foundingYear: undefined,
    marketSize: undefined,
    funding: {} as any,
    about: undefined,
  };

  /**
   *
   */
  loading = false;
  /**
   * @param score
   */
  submit() {
    this.loading = true;
    this.$api.main
      .patch<Business>(`/v1/businesses/${this.business._id}`, this.form)
      .then((resp) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "success",
          message: "Updated business profile successfully!",
        });
        this.makeUpdatesAfterCreate(resp.data);
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err),
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  /**
   * @triggers updates after creating a new business profile
   */
  @Emit("update")
  makeUpdatesAfterCreate(business: Business) {
    this.loading = true;
    this.closeModal();
    FounderAccountUtil.finalizeFounderFetch(
      this.$store,
      this.$store.state.account.user as User
    );
    return business;
  }

  /**
   * Close modal
   */
  @Emit("closed")
  closeModal() {
    console.log("Clicked close the modal");
  }

  editFields = [
    "name",
    "industry",
    "businessModel",
    "location",
    "stage",
    "teamSize",
    "website",
    "foundingYear",
    "marketSize",
    "funding",
    "about",
  ];

  /**
   *
   */
  @Emit("opened")
  opened() {
    this.assignForm();
  }

  assignForm() {
    this.form = Object.assign(
      {},
      ObjectUtil.pick(this.business, this.editFields) as any
    );
    this.form.funding =
      typeof this.business.funding === "object" ? this.business.funding : {};
  }

  get disabledSave() {
    return false;
  }
}
</script>

<style lang="scss">
.App-Create-Business-Modal {
  .App-Styled-Form {
    max-width: 400px;
    margin: auto;
  }
}
</style>
